import { Box, useTheme } from "@mui/material";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-react";
import { reactMarkdownComp } from "../../../../../../../Constants/reactMarkdownComp";
import useTab from "../../../../hooks/useTab";
import { ItemContentContainer, ItemWrapper } from "../../../../style";
import TitleWrapper from "../../../TitleWrapper";

type Props = {
  output: any;
  index: number;
  isClosed: boolean;
  handleCollapse: (index: number) => () => void;
};

const ErrorBlock = ({ output, index, isClosed, handleCollapse }: Props) => {
  const { palette } = useTheme();
  const { animationStyles } = useTab({ isClosed });

  return (
    <ItemWrapper sx={{ background: palette.error.lighter }}>
      <TitleWrapper
        title="Error"
        handleCollapse={handleCollapse}
        index={index}
        animationStyles={animationStyles}
      />
      <ItemContentContainer sx={animationStyles.displayContainer}>
        <Box>
          <ReactMarkdown
            children={output}
            //remarkPlugins={[remarkGfm]} removed because it was causing the markdown to not render properly
            rehypePlugins={[rehypeRaw] as any}
            components={reactMarkdownComp}
          />
        </Box>
      </ItemContentContainer>
    </ItemWrapper>
  );
};

export default ErrorBlock;
